import AuthService from '../services/auth.service'
import GlobalDataService from '../services/GlobalDataService'
import type { LoginRequest, LoginResponse, ConfirmAccountRequest, ForgotPasswordRequest, ConfirmForgotPasswordRequest } from '../services/auth.service'
// @ts-ignore: don't complain about Vuex's misconfigured typings
import type { Commit } from 'vuex'

const userJson = localStorage.getItem('user')
const user = userJson === null ? null : JSON.parse(userJson)

interface AuthStoreUser {
  // TODO
}

interface AuthStoreState {
  status: { loggedIn: boolean }
  user: null | AuthStoreUser
}

const initialState: AuthStoreState = user
  ? { status: { loggedIn: true }, user }
  : { status: { loggedIn: false }, user: null }

export const auth = {
  namespaced: true,
  state: initialState,
  actions: {
    login({ commit }: { commit: Commit }, request: LoginRequest): Promise<LoginResponse['user']> {
      return AuthService.login(request).then(
        (response: LoginResponse): Promise<LoginResponse['user']> => {
          commit('loginSuccess', response.user)
          return Promise.resolve(response.user)
        },
        (error) => {
          commit('loginFailure')
          return Promise.reject(error)
        }
      )
    },
    logout({ commit }: { commit: Commit }) {
      AuthService.logout()
      GlobalDataService.purge()
      commit('logout')
    },
    confirmAccount({ commit }: { commit: Commit }, request: ConfirmAccountRequest) {
      return AuthService.confirmAccount(request).then(
        (newUser) => {
          commit('accountConfirmSuccess', newUser)
          return Promise.resolve(newUser)
        },
        (error) => {
          // commit('accountConfirmFailure')
          return Promise.reject(error)
        }
      )
    },
    forgotPassword({ commit }: { commit: Commit }, request: ForgotPasswordRequest) {
      return AuthService.forgotPassword(request).then(
        (newUser) => {
          commit('forgotPasswordSuccess', newUser)
          return Promise.resolve(newUser)
        },
        (error) => {
          commit('forgotPasswordFailure')
          return Promise.reject(error)
        }
      )
    },
    confirmForgotPassword({ commit }: { commit: Commit }, request: ConfirmForgotPasswordRequest) {
      return AuthService.confirmForgotPassword(request).then(
        (newUser) => {
          commit('confirmForgotPasswordSuccess', newUser)
          return Promise.resolve(newUser)
        },
        (error) => {
          commit('confirmForgotPasswordFailure')
          return Promise.reject(error)
        }
      )
    },
  },
  mutations: {
    loginSuccess(state: AuthStoreState, user: LoginResponse['user']) {
      state.status.loggedIn = true
      state.user = user
    },
    loginFailure(state: AuthStoreState) {
      state.status.loggedIn = false
      state.user = null
    },
    logout(state: AuthStoreState) {
      state.status.loggedIn = false
      state.user = null
    },
    accountConfirmSuccess(state: AuthStoreState) {
      state.status.loggedIn = false
      state.user = null
    },
    forgotPasswordSuccess(state: AuthStoreState) {
      state.status.loggedIn = false
      state.user = null
    },
    forgotPasswordFailure(state: AuthStoreState) {
      state.status.loggedIn = false
      state.user = null
    },
    confirmForgotPasswordSuccess(state: AuthStoreState) {
      state.status.loggedIn = false
      state.user = null
    },
    confirmForgotPasswordFailure(state: AuthStoreState) {
      state.status.loggedIn = false
      state.user = null
    },

    updateUser(state: AuthStoreState, user: LoginResponse['user']) {
      let updatedUser = {
        ...state.user,
        firstName: user.firstName,
        email: user.email,
        lastName: user.lastName,
        phone: user.phone,
        role: user.role,
        receiveSummaryEmails: user.receiveSummaryEmails,
      }
      state.user = updatedUser

      localStorage.setItem('user', JSON.stringify(updatedUser))
    },
  },
}
